var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAutomated(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.6673 17.3333C26.6673 23.9999 22.0007 27.3333 16.454 29.2666C16.1635 29.365 15.848 29.3603 15.5607 29.2533C10.0007 27.3333 5.33398 23.9999 5.33398 17.3333V7.99995C5.33398 7.64633 5.47446 7.30719 5.72451 7.05714C5.97456 6.80709 6.3137 6.66662 6.66732 6.66662C9.33398 6.66662 12.6673 5.06662 14.9873 3.03995C15.2698 2.79861 15.6291 2.66602 16.0007 2.66602C16.3722 2.66602 16.7315 2.79861 17.014 3.03995C19.3473 5.07995 22.6673 6.66662 25.334 6.66662C25.6876 6.66662 26.0267 6.80709 26.2768 7.05714C26.5268 7.30719 26.6673 7.64633 26.6673 7.99995V17.3333Z",
    stroke: "#142454",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutomated);
export default __webpack_public_path__ + "static/media/Automated.19a38c299225d0f91407e930e2523aa2.svg";
export { ForwardRef as ReactComponent };